import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function IletisimPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 5000);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-cream to-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-primary-navy/5 to-gold/5"></div>
        <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="font-serif text-5xl md:text-6xl font-bold text-primary-dark mb-6">
              İletişim
            </h1>
            <p className="text-lg text-text-secondary leading-relaxed">
              Sorularınız, randevu talepleriniz veya işbirliği önerileriniz için 
              bizimle iletişime geçin. Size yardımcı olmaktan mutluluk duyarız.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Contact Info */}
            <div>
              <h2 className="font-serif text-3xl font-bold text-primary-dark mb-8">
                İletişim Bilgileri
              </h2>

              <div className="space-y-6 mb-12">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-gold/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-gold text-xl"></i>
                  </div>
                  <div>
                    <h3 className="font-medium text-primary-dark mb-1">E-posta</h3>
                    <a
                      href="mailto:info@denizerin.com"
                      className="text-text-secondary hover:text-gold transition-colors duration-300 cursor-pointer"
                    >
                      info@denizerin.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-gold/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-gold text-xl"></i>
                  </div>
                  <div>
                    <h3 className="font-medium text-primary-dark mb-1">Telefon</h3>
                    <a
                      href="tel:+905366460317"
                      className="text-text-secondary hover:text-gold transition-colors duration-300 cursor-pointer"
                    >
                      +90 536 646 03 17
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-gold/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-whatsapp-line text-gold text-xl"></i>
                  </div>
                  <div>
                    <h3 className="font-medium text-primary-dark mb-1">WhatsApp</h3>
                    <a
                      href="https://wa.me/905366460317"
                      target="_blank"
                      rel="nofollow noopener noreferrer"
                      className="text-text-secondary hover:text-gold transition-colors duration-300 cursor-pointer"
                    >
                      +90 536 646 03 17
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-gold/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-time-line text-gold text-xl"></i>
                  </div>
                  <div>
                    <h3 className="font-medium text-primary-dark mb-1">Çalışma Saatleri</h3>
                    <p className="text-text-secondary">Pazartesi - Cuma: 09:00 - 20:00</p>
                    <p className="text-text-secondary">Cumartesi: 10:00 - 18:00</p>
                    <p className="text-text-secondary">Pazar: Kapalı</p>
                  </div>
                </div>
              </div>

              {/* Social Media */}
              <div>
                <h3 className="font-serif text-2xl font-bold text-primary-dark mb-6">
                  Sosyal Medya
                </h3>
                <div className="flex items-center gap-4">
                  <a
                    href="https://instagram.com"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className="w-12 h-12 rounded-full border-2 border-gold/30 flex items-center justify-center text-gold hover:bg-gold hover:text-primary-dark transition-all duration-300 cursor-pointer"
                    aria-label="Instagram"
                  >
                    <i className="ri-instagram-line text-xl"></i>
                  </a>
                  <a
                    href="https://youtube.com"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className="w-12 h-12 rounded-full border-2 border-gold/30 flex items-center justify-center text-gold hover:bg-gold hover:text-primary-dark transition-all duration-300 cursor-pointer"
                    aria-label="YouTube"
                  >
                    <i className="ri-youtube-line text-xl"></i>
                  </a>
                  <a
                    href="https://tiktok.com"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className="w-12 h-12 rounded-full border-2 border-gold/30 flex items-center justify-center text-gold hover:bg-gold hover:text-primary-dark transition-all duration-300 cursor-pointer"
                    aria-label="TikTok"
                  >
                    <i className="fab fa-tiktok text-xl"></i>
                  </a>
                  <a
                    href="https://linkedin.com"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className="w-12 h-12 rounded-full border-2 border-gold/30 flex items-center justify-center text-gold hover:bg-gold hover:text-primary-dark transition-all duration-300 cursor-pointer"
                    aria-label="LinkedIn"
                  >
                    <i className="ri-linkedin-line text-xl"></i>
                  </a>
                </div>
              </div>

              {/* Quick Actions */}
              <div className="mt-12 p-6 bg-gradient-to-br from-primary-navy to-primary-dark rounded-2xl">
                <h3 className="font-serif text-xl font-bold text-white mb-4">
                  Hızlı İşlemler
                </h3>
                <div className="space-y-3">
                  <a
                    href="/randevu"
                    className="flex items-center justify-between px-4 py-3 bg-white/10 rounded-lg hover:bg-white/20 transition-all duration-300 cursor-pointer"
                  >
                    <span className="text-white text-sm">Online Randevu Al</span>
                    <i className="ri-arrow-right-line text-gold"></i>
                  </a>
                  <a
                    href="/egitimler"
                    className="flex items-center justify-between px-4 py-3 bg-white/10 rounded-lg hover:bg-white/20 transition-all duration-300 cursor-pointer"
                  >
                    <span className="text-white text-sm">Eğitimleri İncele</span>
                    <i className="ri-arrow-right-line text-gold"></i>
                  </a>
                  <a
                    href="/sss"
                    className="flex items-center justify-between px-4 py-3 bg-white/10 rounded-lg hover:bg-white/20 transition-all duration-300 cursor-pointer"
                  >
                    <span className="text-white text-sm">S.S.S.</span>
                    <i className="ri-arrow-right-line text-gold"></i>
                  </a>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div>
              <div className="bg-white rounded-2xl shadow-xl p-8">
                <h2 className="font-serif text-3xl font-bold text-primary-dark mb-8">
                  Mesaj Gönderin
                </h2>

                {submitted && (
                  <div className="mb-6 p-4 bg-gold/10 border border-gold/30 rounded-lg">
                    <p className="text-sm text-primary-dark flex items-center gap-2">
                      <i className="ri-checkbox-circle-fill text-gold"></i>
                      Mesajınız alınmıştır. En kısa sürede size dönüş yapılacaktır.
                    </p>
                  </div>
                )}

                <form onSubmit={handleSubmit} className="space-y-6">
                  <div>
                    <label className="block text-sm font-medium text-primary-dark mb-2">
                      Ad Soyad *
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 border border-gold/30 rounded-lg focus:outline-none focus:border-gold transition-colors duration-300 text-sm"
                      placeholder="Adınız ve soyadınız"
                    />
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-sm font-medium text-primary-dark mb-2">
                        E-posta *
                      </label>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        className="w-full px-4 py-3 border border-gold/30 rounded-lg focus:outline-none focus:border-gold transition-colors duration-300 text-sm"
                        placeholder="ornek@email.com"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-primary-dark mb-2">
                        Telefon
                      </label>
                      <input
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        className="w-full px-4 py-3 border border-gold/30 rounded-lg focus:outline-none focus:border-gold transition-colors duration-300 text-sm"
                        placeholder="+90 555 555 55 55"
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-primary-dark mb-2">
                      Konu *
                    </label>
                    <select
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 border border-gold/30 rounded-lg focus:outline-none focus:border-gold transition-colors duration-300 text-sm cursor-pointer"
                    >
                      <option value="">Konu seçiniz</option>
                      <option value="randevu">Randevu Talebi</option>
                      <option value="egitim">Eğitim Bilgisi</option>
                      <option value="hizmet">Hizmet Bilgisi</option>
                      <option value="isbirligi">İşbirliği Önerisi</option>
                      <option value="diger">Diğer</option>
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-primary-dark mb-2">
                      Mesajınız *
                    </label>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                      rows={6}
                      maxLength={500}
                      className="w-full px-4 py-3 border border-gold/30 rounded-lg focus:outline-none focus:border-gold transition-colors duration-300 text-sm resize-none"
                      placeholder="Mesajınızı buraya yazın..."
                    ></textarea>
                    <p className="text-xs text-text-secondary mt-1">
                      Maksimum 500 karakter
                    </p>
                  </div>

                  <button
                    type="submit"
                    className="w-full px-8 py-4 bg-gold text-primary-dark rounded-full font-medium text-lg hover:shadow-lg hover:shadow-gold/50 transition-all duration-300 cursor-pointer whitespace-nowrap"
                  >
                    Mesaj Gönder
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}